// extracted by mini-css-extract-plugin
module.exports = {"container":"address_container__TiGpi","container__logo":"address_container__logo___0JK5"};